<template>
  <b-dropdown
    :text="filter_is_active_label"
    variant="dropdown-curve"
    class="ml-auto mr-3 filter-status-dropdown"
  >
    <b-dropdown-item @click="onChangeFilterIsActive('Active')"
      >Active</b-dropdown-item
    >
    <b-dropdown-item @click="onChangeFilterIsActive('Inactive')"
      >Inactive</b-dropdown-item
    >
    <b-dropdown-item @click="onChangeFilterIsActive('All')"
      >All</b-dropdown-item
    >
    <b-dropdown-item
      v-if="unapproved"
      @click="onChangeFilterIsActive('Unapproved')"
      >Unapproved</b-dropdown-item
    >
  </b-dropdown>
</template>
<script>
import { EventBus } from "@/main";

export default {
  name: "FilterByStatusDropdown",
  props: {
    onSelect: {
      type: Function,
      default: this.onChangeFilterIsActive
    },

    unapproved: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      filter_is_active_label: "Active",
      filterIsActive: "Y"
    };
  },
  beforeMount() {
    EventBus.$on("STATUS_CHANGE", data => {
      console.log(data, "STATUS_CHANGE");
      this.onChangeFilterIsActiveStatus(data);
    });
  },
  methods: {
    onChangeFilterIsActive(option) {
      this.filter_is_active_label = option;
      switch (option.toLowerCase()) {
        case "active":
          this.filterIsActive = "Y";
          break;
        case "inactive":
          this.filterIsActive = "N";
          break;
        case "all":
          this.filterIsActive = "A";
          break;
        case "unapproved":
          this.filterIsActive = "U";
          break;
        default:
          this.filterIsActive = null;
          break;
      }
      this.onSelect && this.onSelect(this.filterIsActive);
    },
    onChangeFilterIsActiveStatus(option) {
      this.filterIsActive = option;
      switch (option.toLowerCase()) {
        case "y":
          this.filter_is_active_label = "Active";
          break;
        case "n":
          this.filter_is_active_label = "Inactive";
          break;
        case "a":
          this.filter_is_active_label = "All";
          break;
        case "u":
          this.filter_is_active_label = "unapproved";
          break;
        default:
          this.filter_is_active_label = null;
          break;
      }
    }
  }
};
</script>
<style>
.filter-status-dropdown button {
  padding-right: 28px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Partials/FilterByStatusDropdown.vue